import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../../assets/color';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PersonSvg } from '../../../../assets/svg';
import RouteHeader from '../../../../components/common/RouteHeader';
import DatatableHeading from '../../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../../redux/actions/superadminAction';

const AdminPartner = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParam, setSearchParam] = useSearchParams();
    const adminId = searchParam.get('id') || '';
    const admin_name = searchParam.get('name') || '';

    const { partnerByAdminIdData } = useSelector(state => state?.superadminReducer);

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => partnerByAdminIdData?.indexOf(row) + 1, width: '80px' },
        { name: 'Partner Name', selector: row => row?.partner_name },
        { name: 'Reg.No.', selector: row => row?.registration_number },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Password', selector: row => row?.password || '...' },
        { name: 'Wallet Balance', selector: row => row?.report_wallet_balance || '...' },
        { name: 'Affiliates', selector: row => row?.affiliateCount ?? '...' },
        { name: 'Status', selector: row => row?.is_active ? 'Active' : 'Inactive' },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => navigate(`/management/admins/partner/affiliates?name=${row?.partner_name}&id=${row?._id}`)} style={{ cursor: "pointer" }}><PersonSvg /></div>
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getPartnerByAdminId({ adminId }));
    }, []);

    return (
        <>
            <RouteHeader title={`${admin_name} Partners`} sub_title={`View partners information`} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={`${admin_name} Partners Management Information System`} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={partnerByAdminIdData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default AdminPartner;